<template>
  <form
    v-on:submit.prevent="onSubmit"
    class="form-category">
    <input-text
      class="form-category__input"
      placeholder="Наименование"
      title="Наименование"
      v-bind:maxlength="200"
      v-bind:violations="nameInputErrors"
      v-letter-capital
      v-model="name" />
    <div class="form-category__buttons">
      <button
        class="form-category__button-cancel"
        type="button"
        v-on:click="onClose">Отмена</button>
      <button
        class="form-category__button-save"
        type="submit">
        {{ this.isEdit ? "Сохранить" : "Создать" }}
      </button>
    </div>
  </form>
</template>

<script>
import InputText from '@/components/InputText.vue';
import { ProductCategoryRequest } from '@/storage/gateways/ProductGateway';

/**
 * @description Название события подтверждения.
 * @type {string}
 */
const NAME_EVENT_SUBMIT = 'submit';

/**
 * @description Название события закрытия.
 * @type {string}
 */
const NAME_EVENT_CLOSE = 'close';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Форма категории товара.
 * @type {Vue}
 */
export default {
  name: 'FormProductCategory',
  components: { InputText },
  computed: {
    nameInputErrors: resolveInputErrors('category.name'),
    /**
     * @description Редактируется.
     * @returns {boolean}
     */
    isEdit() {
      return this.categoryId !== '';
    },
  },
  data() {
    return {
      name: this.initialName,
      manufacturer: this.initialManufacturer,
      category: this.initialCategory,
      unit: this.initialUnit,
    };
  },
  methods: {
    /**
     * @description Обработать закрытие формы.
     * @returns {void}
     */
    onClose() {
      this.$emit(NAME_EVENT_CLOSE);
    },
    /**
     * @description Обработать отправку формы.
     * @returns {void}
     */
    onSubmit() {
      const request = this.makeRequest();
      this.$emit(NAME_EVENT_SUBMIT, request);
    },
    /**
     * @description Создать запрос.
     * @returns {ProductCategoryRequest}
     */
    makeRequest() {
      return new ProductCategoryRequest(
        this.categoryId ?? null,
        this.name,
      );
    },
  },
  props: {
    /**
     * @description Идентификатор категории.
     */
    categoryId: { type: String, default: () => '' },
    /**
     * @description Начальное наименование.
     */
    initialName: { type: String, default: () => '' },
    /**
     * @description Нарушения ограничений.
     * @type {any}
     */
    inputErrors: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss">
  @use "@/scss/buttons";

 .form-category {
    &__input {
      margin-bottom: 20px;
    }
    &__buttons {
      display: grid;
      grid-template-columns: repeat(2, minmax(100px, 200px));
      gap: 10px 20px;
    }
    &__button-cancel {
      @include buttons.btn-transparent(100%, 48px, 16px);
    }
    &__button-save {
      @include buttons.btn-blue(100%, 48px, 16px);
    }
 }

 @media screen and (max-width: 400px) {
  .form-category {
    &__buttons {
      grid-template-columns: 1fr;
    }
  }
 }
</style>
